export const onboardingQKeys = {
  all: () => ["onboarding"] as const,
  session: () => [...onboardingQKeys.all(), "session"] as const,
  tokenVerification: (token: string) => [...onboardingQKeys.all(), "verify", token] as const,
  queue: () => [...onboardingQKeys.all(), "queue"] as const,
};
